import {CloseBurger, OpenBurger} from "../../animations/burgerMenu/burgerAnimation";
import {fixedScroll} from "../../modules/disablescroll";

function fix_heightNav() {
    const $navHeight = $('#menu-menu-secondaire, .c-navbar__responsive--menu').height();
    const $windowHeight = window.innerHeight;
    const $wrapperNav = $('.c-navbar__second--gauche, .c-navbar__second--droite, .c-navbar__responsive--menu');

    if ($navHeight >= $windowHeight) {
        $wrapperNav.addClass('js-isSmaller');
    }
}

export default function mainNavbar() {

    const $class = {
        active: 'js-isActive'
    }

    const $burger = {
        btn: $('.c-navbar__burger, .c-navbar__second a'),
        bar: {
            top: $('.c-navbar__burger span:nth-child(1)'),
            middle: $('.c-navbar__burger span:nth-child(2)'),
            bottom: $('.c-navbar__burger span:nth-child(3)'),
        }
    }

    const $nav = {
        container: $('.c-navbar__second'),
        gauche: {
            container: $('.c-navbar__second--gauche'),
            items: $('.c-navbar__second--gauche ul li')
        },
        droite: {
            container: $('.c-navbar__second--droite'),
            items: $('.c-navbar__second--droite ul li')
        },
    };

    if ($burger.btn.length > 0 && $nav.container.length > 0) {
        $burger.btn.click(function () {

            if (!$nav.container.hasClass($class.active)) {
                $nav.container.addClass($class.active);
                $('.c-navbar__burger').addClass($class.active);
                OpenBurger();

                /**
                 * Animations coté gauche
                 */
                TweenMax.fromTo($nav.gauche.container, .3, {scaleY: 0, ease: Power3.easeInOut}, {scaleY: 1, ease: Power3.easeInOut});
                TweenMax.fromTo($nav.gauche.items, .3, {opacity: 0, ease: Power3.easeInOut}, {opacity: 1, ease: Power3.easeInOut, delay: .2});

                /**
                 * Animations coté droit
                 */
                TweenMax.fromTo($nav.droite.container, .3, {scaleY: 0, ease: Power3.easeInOut}, {scaleY: 1, ease: Power3.easeInOut, delay: .2});
                TweenMax.fromTo($nav.droite.items, .3, {opacity: 0, ease: Power3.easeInOut}, {opacity: 1, ease: Power3.easeInOut, delay: .4});

                fixedScroll(true);

            } else {
                $nav.container.removeClass($class.active);
                $('.c-navbar__burger').removeClass($class.active);
                /**
                 * Animations burger menu
                 */
                fixedScroll(false);
                CloseBurger();

                setTimeout(function () {
                    /**
                     * Animations coté gauche
                     */
                    TweenMax.fromTo($nav.gauche.container, .3, {scaleY: 1, ease: Power3.easeInOut}, {scaleY: 0, ease: Power3.easeInOut, delay: .4});
                    TweenMax.fromTo($nav.gauche.items, .3, {opacity: 1, ease: Power3.easeInOut}, {opacity: 0, ease: Power3.easeInOut, delay: .2});

                    /**
                     * Animations coté droit
                     */
                    TweenMax.fromTo($nav.droite.container, .3, {scaleY: 1, ease: Power3.easeInOut}, {scaleY: 0, ease: Power3.easeInOut, delay: .2});
                    TweenMax.fromTo($nav.droite.items, .3, {opacity: 1, ease: Power3.easeInOut}, {opacity: 0, ease: Power3.easeInOut,});
                }, 400)
            }
        });
    }

    fix_heightNav();
    $(window).resize(function () {
        fix_heightNav();
    });
}
